module.exports = "/images/measure-line-top-right-bottom-left.svg?b960be7ab1b4ada9ab2b106f23943162";